
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/country/[country]/[id]",
      function () {
        return require("private-next-pages/country/[country]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/country/[country]/[id]"])
      });
    }
  